/**
 * Ad Configuration for 66Movies
 * 
 * This file contains all ad placement configurations for banner ads
 * throughout the application.
 */

export const AD_CONFIG = {
  enabled: process.env.REACT_APP_ADS_ENABLED === 'true' || true,
  network: process.env.REACT_APP_AD_NETWORK || 'adsense', // 'adsense', 'juicyads'
  clientId: process.env.REACT_APP_AD_CLIENT_ID || 'ca-pub-xxxxxxxxxxxxxxxx',
  
  // Ad placements
  placements: {
    // Main page (above content)
    headerAd: {
      enabled: true,
      position: 'top',
      size: 'responsive',
      adSlot: process.env.REACT_APP_AD_SLOT_HEADER || '1234567890',
      refreshInterval: 60000, // 60 seconds
    },
    
    // Scenes/Content listing page
    scenesPageTopAd: {
      enabled: true,
      position: 'top',
      size: '728x90',
      adSlot: process.env.REACT_APP_AD_SLOT_SCENES_TOP,
      juicyAdsZoneId: process.env.REACT_APP_JUICYADS_ZONE_SCENES_TOP,
    },

    scenesPageLeftAd: {
      enabled: true,
      position: 'side',
      size: '300x250',
      adSlot: process.env.REACT_APP_AD_SLOT_SCENES_SIDEBAR,
      juicyAdsZoneId: process.env.REACT_APP_JUICYADS_ZONE_SCENES_LEFT,
    },

    scenesPageCardAd: {
      enabled: true,
      position: 'card',
      size: '300x250',
      adSlot: process.env.REACT_APP_AD_SLOT_SCENES_SIDEBAR,
      juicyAdsZoneId: process.env.REACT_APP_JUICYADS_ZONE_SCENES_CARD,
    },

    scenesPageRightAd: {
      enabled: true,
      position: 'side',
      size: '300x250',
      adSlot: process.env.REACT_APP_AD_SLOT_SCENES_SIDEBAR,
      juicyAdsZoneId: process.env.REACT_APP_JUICYADS_ZONE_SCENES_RIGHT,
    },

    scenesPageSidebarAd: {
      enabled: true,
      position: 'sidebar',
      size: '300x250',
      adSlot: process.env.REACT_APP_AD_SLOT_SCENES_SIDEBAR || '1234567892',
    },

    scenesPageBottomAd: {
      enabled: true,
      position: 'bottom',
      size: '728x90',
      adSlot: process.env.REACT_APP_AD_SLOT_SCENES_BOTTOM || '1234567893',
    },

    // Movies page
    moviesPageAd: {
      enabled: true,
      position: 'top',
      size: '728x90',
      adSlot: process.env.REACT_APP_AD_SLOT_MOVIES || '1234567894',
    },

    // Actors page
    actorsPageAd: {
      enabled: true,
      position: 'top',
      size: '728x90',
      adSlot: process.env.REACT_APP_AD_SLOT_ACTORS || '1234567895',
    },

    // Shows page
    showsPageAd: {
      enabled: true,
      position: 'top',
      size: '728x90',
      adSlot: process.env.REACT_APP_AD_SLOT_SHOWS || '1234567896',
    },

    // Scene video pre-roll (VAST tag URL from the ad network)
    scenePrerollAd: {
      enabled: true,
      vastUrl: process.env.REACT_APP_VAST_PREROLL_URL,
      juicyAdsZoneId: process.env.REACT_APP_JUICYADS_ZONE_SCENE_PREROLL,
      width: 308,
      height: 286,
    },

    // Footer ad (sticky)
    stickyFooterAd: {
      enabled: true,
      position: 'bottom',
      size: '320x50',
      adSlot: process.env.REACT_APP_AD_SLOT_FOOTER || '1234567897',
    },
  },

  // Ad display rules
  rules: {
    // Users on these tiers never see ads
    adFreeTiers: ['premium', 'premium_plus'],

    // Hide ads on certain pages
    hiddenPages: [
      '/admin',
      '/profile',
      '/settings',
    ],

    // Show ads after user has spent X seconds on page
    minPageTimeMs: 2000,

    // Minimum number of ads to show per session
    minAdsPerSession: 1,

    // Maximum ads per page
    maxAdsPerPage: 3,
  },

  // Revenue tracking
  tracking: {
    enabled: true,
    trackImpressions: true,
    trackClicks: true,
    trackConversions: true,
  },
};

/**
 * Get ad configuration for a specific placement
 * @param {string} placementName - Name of the placement
 * @returns {Object} Ad configuration
 */
export const getAdPlacement = (placementName) => {
  return {
    ...AD_CONFIG.placements[placementName],
    network: AD_CONFIG.network,
  };
};

/**
 * Check if ads are enabled globally
 * @returns {boolean}
 */
export const areAdsEnabled = () => {
  return AD_CONFIG.enabled;
};

/**
 * Check if ads should be hidden for current user
 * @param {Object} user - User object
 * @returns {boolean}
 */
export const shouldHideAds = (user) => {
  if (!user || !user.tier) return false;
  return AD_CONFIG.rules.adFreeTiers.includes(user.tier);
};

export default AD_CONFIG;
